import { Result } from 'src_common/common/mobx-utils/Form2/FormModel';

type GetTranslationType = (id: string, defaultText: string) => string;

export const validatePromoCode =
    (getTranslation: GetTranslationType) =>
    (value: string): Result<string> => {
        const REGEXP = /^[a-zA-Z0-9]*$/;
        if (!REGEXP.test(value)) {
            return Result.createError(
                getTranslation(
                    'errors.promoCode',
                    'Promo codes must include only alphanumeric characters (A-Z, a-z, 0-9).'
                )
            );
        }

        return Result.createOk(value);
    };
